import React, { Component } from "react";
import { Row, Col, Space, Image, Button } from "antd";
import LinkedinImg from "../assets/images/Icon_Linkedin_circle.png";
import InstagramImg from "../assets/images/Icon_Instagram_circle.png";
import pdfFile from "./mornaResume.pdf";
import "../App.css";
export default class Home extends Component {
  download = () => {
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = "mornaYangResume.pdf"; // 你可以根据需要更改文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  render() {
    return (
      <>
        <Row>
          <Col span={24} className="colCenter">
            <div className="nameTitle">
              <Image
                src={`${process.env.PUBLIC_URL}/images/NameLogo.svg`}
                alt="Name Logo"
                className="nameImg"
                preview={false}
              />
            </div>
          </Col>
          <Col span={24} className="colCenter">
            <div className="subTitle">
              Visual Development & Background Artist
            </div>
          </Col>
          <Col span={24}>
            <div className="imgDiv">
              <Image
                src={`${process.env.PUBLIC_URL}/images/jpg/place.jpg`}
                className="placeImg"
                preview={false}
                placeholder={
                  <Image
                    alt="Place Image"
                    className="placeImg"
                    src={`${process.env.PUBLIC_URL}/images/jpg/place_blur.jpg`}
                    preview={false}
                  />
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20} className="homeContent">
            <Row>
              <Col xs={24} sm={24} md={16} lg={16} xl={14}>
                <div className="f4EM color110 fAN">About Me</div>
                <div className="f2EM color157 fAN paddTop10">
                  My name is Morna (Zixie) Yang
                </div>
                <div className="f1-2EM paddTop40 lh1-5EM txtAlignBetween">
                  Hi, I'm Morna (Zixie)—a visual development artist and
                  background painter based in Vancouver, Canada. I’m passionate
                  about world-building, using intricate details and design to
                  shape stories and mood. Whether in animation, games, or
                  illustration, I strive to create immersive environments that
                  spark imagination and emotion. I'm always open to new
                  opportunities—feel free to connect!
                </div>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={10} className="txtCenter">
                <div className="mornaDiv">
                  <Image
                    alt="Morna Image"
                    src={`${process.env.PUBLIC_URL}/images/jpg/Morna.jpg`}
                    className="mornaImg"
                    preview={false}
                    placeholder={
                      <Image
                        className="mornaImg"
                        src={`${process.env.PUBLIC_URL}/images/jpg/Morna_blur.jpg`}
                        preview={false}
                      />
                    }
                  />
                </div>
              </Col>
              <Col span={24}>
                <div className="txtIcon">
                  <Space size="small">
                    <a
                      href="https://www.linkedin.com/in/morna-yang-b17b69290/"
                      target="_blank"
                    >
                      <Image
                        src={LinkedinImg}
                        alt="Linkedin Icon"
                        width={24}
                        preview={false}
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/morna_zy/"
                      target="_blank"
                    >
                      <Image
                        src={InstagramImg}
                        alt="Linkedin Icon"
                        width={24}
                        preview={false}
                      />
                    </a>
                  </Space>
                </div>
                <div>
                  <Button className="pdfBtn" onClick={this.download}>
                    Resume
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
      </>
    );
  }
}
